const urlsRewrite = [
  // 'https://mq3u5mdcc5.execute-api.us-east-1.amazonaws.com/prod/rewrite',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/uqqqhblqcq',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/yqsgbhrfgr',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/zlsbxcagex',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/lvsmjkriff',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/ltxbjtykpy',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/zdgryfncbn',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/gdwjfwzxpg',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/wpjnxhqrve',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/ipawyhbffv',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/kppbebxntv',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/jgblxrrpdc',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/zmuerrczxm',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/qzymqfyxob',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/sdjvjysees',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/zopiupgdwe',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/dmbybjwfju',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/rtokzmoiws',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/meqrqsbmhc',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/pbuwmcunuc',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/ffchacbwtq',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/RWBLxVDJSo',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/BOKLNldKIc',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/IWQRVvIGbT',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/ncOqgcUbZg',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/FypzLmaDSB',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/dLWBUQGteT',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/dFNJwBLhsS',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/tgqbQokkmA',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/ynLLQgbEEm',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/uOZPChfInt',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/XjKjceiNcu',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/UfmGmjGHbJ',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/FGOJrjZZFD',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/xBVNWGalyT',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/qMUzNqUhnL',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/VTQBWnWTZS',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/OKbNADPoKU',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/WknlEUkujt',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/wgcwasGVWq',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/hMoezEaUIz',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/RnoauopAXi',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/EgGskzFbpD',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/VsxBspWNsV',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/yUdIwjUHXP',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/mzUrfLNWsM',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/NHLKuAHlzb',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/XfALcPnDBT',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/lRQybhAzAc',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/pypwUYLHQV',
  'https://qi63n07srh.execute-api.us-east-1.amazonaws.com/prod/zVUiKzapCV'
]


const urlRewrite = async () => urlsRewrite[(Math.random() * urlsRewrite.length) | 0]

export { urlRewrite }
